/**
 * 排名折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const rankingLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'ranking-line-unique-x-values',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const xValues = new Set(
          data.map((item: Record<string, unknown>) => item[encoding?.x as string])
        );
        return xValues.size > 2;
      },
      message: 'Ranking line requires more than 2 unique x-axis values',
      suggestion: 'Provide more time points for ranking comparison',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'ranking-line-sufficient-categories',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const zValues = new Set(
          data.map((item: Record<string, unknown>) => item[encoding?.z as string])
        );
        return zValues.size > 3;
      },
      message: 'Ranking line requires more than 3 unique categories for effective ranking',
      suggestion: 'Provide at least 4 categories for ranking visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
